import { groq } from 'next-sanity';
import { z } from 'zod';

import { link, SanityLink } from './link';

export const SanityFormConfirmation = z.object({
  headline: z.string().optional().nullable(),
  bodyCopy: z.string(),
  cta: SanityLink.optional().nullable(),
});
export type SanityFormConfirmation = z.infer<typeof SanityFormConfirmation>;

export const formConfirmation = groq`{
  headline,
  bodyCopy,
  cta[0] ${link},
}`;
